document.addEventListener("DOMContentLoaded", () => {
  // ===== Wishlist Config =====
  const STORAGE_KEY = "custom_wishlist";
  const STOREFRONT_ACCESS_TOKEN = "c68cc655c39e6fc87c4d52a1b920bf37";
  const wishlistContainer = document.getElementById("wishlist-products-container");
  const wishlistEmpty = document.getElementById("wishlist-empty");
  const clearBtn = document.getElementById("wishlist-clear-btn");
  const wishlistCountEls = document.querySelectorAll(".wishlist-icon-count");
  const viewControlWrapper = document.querySelector(".wishlist-view-controls");
  const isWishlistPage = !!wishlistContainer;

  // ===== LocalStorage Helpers =====
  const getWishlist = () => JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  const setWishlist = (items) => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));

  // ===== Wishlist Count UI =====
  const updateCount = () => {
    const count = getWishlist().length;
    wishlistCountEls.forEach((el) => (el.textContent = count));
    if (clearBtn) clearBtn.style.display = count > 0 ? "inline-block" : "none";
    if (isWishlistPage && wishlistEmpty)
      wishlistEmpty.style.display = count === 0 ? "block" : "none";
  };

  // ===== Check if product in wishlist =====
  const isInWishlist = (handle) => getWishlist().includes(handle);

  // ===== Update All Heart Buttons =====
  const updateAllButtons = () => {
    document.querySelectorAll(".wishlist-button, .wishlist-btn, .wishlist-action-btn").forEach((btn) => {
      const handle = btn.dataset.handle || btn.dataset.productHandle;
      const active = isInWishlist(handle);
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active);
    });
  };

  // ===== Toggle Wishlist =====
  const toggleWishlist = (handle) => {
    let items = getWishlist();
    const isRemoving = items.includes(handle);

    if (isRemoving) {
      items = items.filter((h) => h !== handle);
      if (isWishlistPage) {
        const card = document.querySelector(`.wishlist-product-card[data-handle="${handle}"]`);
        if (card) card.remove();
        if (
          wishlistContainer &&
          wishlistContainer.querySelectorAll(".wishlist-product-card").length === 0 &&
          wishlistEmpty
        ) {
          wishlistEmpty.style.display = "block";
          wishlistContainer.style.display = "none";
        }
      }
    } else {
      items.push(handle);
      if (isWishlistPage) renderWishlistProducts();
    }

    setWishlist(items);
    updateCount();
    updateAllButtons();
  };

  // ===== Event Listeners =====
  document.body.addEventListener("click", (e) => {
    const btnWishlist = e.target.closest(".wishlist-button, .wishlist-btn, .wishlist-action-btn");
    const btnClear = e.target.closest("#wishlist-clear-btn");

    if (btnWishlist) {
      const handle =
        btnWishlist.dataset.handle ||
        btnWishlist.getAttribute("data-handle") ||
        btnWishlist.getAttribute("data-product-handle");
      if (!handle) return;
      e.preventDefault();
      toggleWishlist(handle);
    } else if (btnClear) {
      e.preventDefault();
      setWishlist([]);
      updateCount();
      updateAllButtons();
      if (isWishlistPage) renderWishlistProducts();
    }
  });

  // ===== Initialize UI =====
  updateCount();
  updateAllButtons();

  // ===== Render Wishlist Page =====
  if (isWishlistPage) {
    const formatCurrency = (amount, currencyCode) =>
      new Intl.NumberFormat("en", { style: "currency", currency: currencyCode }).format(amount);

    const productCache = new Map();
    const fetchProductByHandlePage = async (handle) => {
      if (productCache.has(handle)) return productCache.get(handle);
      const query = `
        {
          productByHandle(handle: "${handle}") {
            title
            handle
            onlineStoreUrl
            availableForSale
            images(first: 2) { edges { node { originalSrc altText } } }
            priceRange { minVariantPrice { amount currencyCode } }
            compareAtPriceRange { minVariantPrice { amount } }
          }
        }`;
      const res = await fetch("/api/2023-04/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ query }),
      });
      const json = await res.json();
      const product = json?.data?.productByHandle || null;
      if (product) productCache.set(handle, product);
      return product;
    };

   const createWishlistCard = (product) => {
  const card = document.createElement("div");
  card.className = "wishlist-product-card";
  card.dataset.handle = product.handle;

  const title = product.title;
  const url = `/products/${product.handle}`;
  const firstImage = product.images.edges[0]?.node.originalSrc || "";
  const secondImage = product.images.edges[1]?.node.originalSrc || "";
  const price = parseFloat(product.priceRange.minVariantPrice.amount);
  const currency = product.priceRange.minVariantPrice.currencyCode;
  const compare = parseFloat(product.compareAtPriceRange.minVariantPrice?.amount || 0);
  const onSale = compare > price;
  const percentOff = onSale ? Math.round(((compare - price) / compare) * 100) : 0;
  const priceFormatted = formatCurrency(price, currency);
  const compareFormatted = formatCurrency(compare, currency);

  card.innerHTML = `
    <div class="custom-card">
      <!-- ❤️ Wishlist icon ABOVE image -->
      <div class="custom-card-top">
        <button class="wishlist-btn active" data-handle="${product.handle}" aria-pressed="true">
          <svg fill="#000000" height="20px" width="20px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <g><path d="M365.109,44.405c-42.169,0-81.27,17.539-109.109,48.529c-27.839-30.99-66.941-48.529-109.109-48.529
                  C65.895,44.405,0,110.3,0,191.296c0,43.071,16.216,84.357,48.196,122.708c26.609,31.909,58.993,56.065,82.64,73.703l3.208,2.394
                  c49.059,36.648,53.157,39.031,92.364,61.837c6.895,4.01,14.89,8.661,24.432,14.256c1.593,0.934,3.376,1.401,5.16,1.401
                  s3.567-0.467,5.159-1.4c9.542-5.595,17.538-10.246,24.432-14.256c39.207-22.805,43.305-25.189,92.364-61.837l3.208-2.394
                  c23.646-17.638,56.031-41.792,82.64-73.703C495.784,275.652,512,234.367,512,191.296
                  C512,110.3,446.105,44.405,365.109,44.405z M368.968,371.356l-3.22,2.402
                  c-48.12,35.945-52.122,38.273-90.412,60.546c-5.632,3.276-11.997,6.978-19.336,11.271
                  c-7.339-4.293-13.705-7.995-19.336-11.271c-38.29-22.272-42.292-24.599-90.412-60.546l-3.22-2.402
                  c-45.867-34.211-122.635-91.472-122.635-180.06c0-69.748,56.744-126.493,126.493-126.493
                  c40.007,0,76.81,18.333,100.972,50.299c1.929,2.55,4.939,4.049,8.137,4.049s6.209-1.499,8.137-4.049
                  c24.162-31.965,60.965-50.299,100.972-50.299c69.748,0,126.493,56.744,126.493,126.493
                  C491.602,279.884,414.833,337.145,368.968,371.356z"></path>
                  <path d="M442.705,129.109c-3.539-4.382-9.962-5.066-14.343-1.526c-4.382,3.54-5.065,9.962-1.526,14.343
                  c11.893,14.726,18.18,32.537,18.18,51.51c0,5.633,4.566,10.199,10.199,10.199c5.633,0,10.199-4.566,10.2-10.2
                  C465.415,170.085,457.35,147.24,442.705,129.109z"></path>
                  <path d="M408.998,101.89c-4.188-2.109-8.557-3.944-12.989-5.452c-5.333-1.815-11.127,1.034-12.943,6.367
                  c-1.815,5.332,1.035,11.126,6.367,12.943c3.544,1.207,7.038,2.674,10.389,4.361c1.472,0.741,3.036,1.092,4.579,1.092
                  c3.731,0,7.325-2.054,9.117-5.615C416.053,110.556,414.03,104.424,408.998,101.89z"></path></g>
                </svg>
        </button>
      </div>

      <!-- 🖼️ Image + Details (Clickable area) -->
      <a href="${url}" class="custom-card-link">
        <div class="custom-card-image-wrapper">
          ${firstImage ? `<img src="${firstImage}" alt="${title}" class="custom-card-image primary-image" loading="lazy">` : ""}
          ${secondImage ? `<img src="${secondImage}" alt="${title}" class="custom-card-image secondary-image" loading="lazy">` : ""}
        </div>
        <div class="custom-card-content">
          <h3 class="custom-card-title">${title}</h3>
          <p class="custom-card-price">
            ${onSale
              ? `<span class="price-sale">${priceFormatted}</span><span class="price-compare">${compareFormatted}</span>`
              : `${priceFormatted}`}
          </p>
          <div class="custom-card-badges">
            ${onSale ? `<div class="sale-badge"><span>${percentOff}% Off</span></div>` : ""}
            ${!product.availableForSale ? `<div class="soldout-badge"><span>Sold Out</span></div>` : ""}
          </div>
        </div>
      </a>
    </div>`;
  return card;
};

    var renderWishlistProducts = async () => {
      const handles = getWishlist();
      wishlistContainer.innerHTML = "";
      if (!handles.length) {
        wishlistContainer.style.display = "none";
        if (wishlistEmpty) wishlistEmpty.style.display = "block";
        return;
      }
      wishlistContainer.style.display = "grid";
      if (wishlistEmpty) wishlistEmpty.style.display = "none";

      const inStock = [];
      const soldOut = [];

      await Promise.all(
        handles.map(async (handle) => {
          const product = await fetchProductByHandlePage(handle);
          if (product) {
            if (product.availableForSale) inStock.push(product);
            else soldOut.push(product);
          }
        })
      );

      [...inStock, ...soldOut].forEach((p) => wishlistContainer.appendChild(createWishlistCard(p)));
    };

    renderWishlistProducts();

    if (viewControlWrapper) viewControlWrapper.style.display = "none";

    const updateViewBasedOnScreenSize = () => {
      const width = window.innerWidth;
      let gridClass = "";
      if (width >= 1440) gridClass = "wishlist-grid-5";
      else if (width >= 1024) gridClass = "wishlist-grid-4";
      else if (width >= 768) gridClass = "wishlist-grid-3";
      else if (width >= 480) gridClass = "wishlist-grid-2";
      else gridClass = "wishlist-grid-1";
      wishlistContainer.className = `wishlist-products-container ${gridClass}`;
    };

    window.addEventListener("resize", updateViewBasedOnScreenSize);
    updateViewBasedOnScreenSize();
  }

  // ===== Fix for button height (theme-specific) =====
  const refButton = document.querySelector("button.button.button--outline.w-full");
  if (refButton) {
    const height = window.getComputedStyle(refButton).height;
    document.documentElement.style.setProperty("--btn-height", height);
  }
});
